import React, { useCallback } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import { t } from '@/i18n'
import { IBreadcrumb } from '@/types'

interface Props {
  breadcrumbs: IBreadcrumb[]
}

const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }) => {
  const navigate: NavigateFunction = useNavigate()
  const onNavigate = useCallback(
    (path?: string) => {
      if (path) {
        navigate(path, { replace: true })
      }
    },
    [navigate],
  )

  return (
    <div className="breadcrumbs">
      <div className="back-btn">
        <a
          href={undefined}
          onClick={e => {
            e.preventDefault()
            navigate(-1)
          }}
        >
          <span className="icon-arrow"></span>
          {t('back')}
        </a>
      </div>

      <ul>
        {breadcrumbs.map(breadcrumb => (
          <li
            key={breadcrumb.name}
            className={breadcrumb.path ? '' : 'no-link'}
            onClick={() => onNavigate(breadcrumb.path)}
          >
            <a
              href={undefined}
              onClick={e => {
                e.preventDefault()
              }}
            >
              {t(breadcrumb.name)}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Breadcrumbs
